import React from 'react';
import {
  Menu,
  MenuItem,
  ProSidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SubMenu,
} from 'react-pro-sidebar';
import { Link } from 'react-router-dom';
import logo from '../../assets/images/logo.png';
import '../../custom.scss';
// import back from "../../assets/images/library.jpg";
import { AiFillPushpin, AiOutlineUsergroupAdd } from 'react-icons/ai';
import { BiMessageSquareAdd, BiTestTube } from 'react-icons/bi';
import { BsBook, BsQuestionSquareFill } from 'react-icons/bs';
import {
  FaChalkboardTeacher,
  FaRegListAlt,
  FaSchool,
  FaTools,
} from 'react-icons/fa';
import { GiTeacher, GiUpgrade } from 'react-icons/gi';
import { ImBooks, ImSortNumericAsc } from 'react-icons/im';
import { IoMdSchool } from 'react-icons/io';
import { IoCreate, IoLibraryOutline } from 'react-icons/io5';
import { MdOutlineLibraryAdd } from 'react-icons/md';
import { RiAdminFill } from 'react-icons/ri';
import { TbMath } from 'react-icons/tb';
// import { IoIosCreate } from "react-icons/io";

export default function SideBar() {
  return (
    <ProSidebar width={'100%'}>
      <SidebarHeader>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            paddingTop: '20px',
            paddingBottom: '20px',
          }}
        >
          <img
            width="80%"
            height="200px"
            src={logo}
            alt="logo"
            style={{ borderRadius: '50%' }}
          />
        </div>
      </SidebarHeader>
      <SidebarContent>
        <Menu>
          <SubMenu icon={<FaSchool />} title="Instituciones">
            <MenuItem icon={<FaSchool />}>
              <Link to="/admin/institutions">Listar instituciones</Link>
            </MenuItem>
            <MenuItem icon={<IoCreate />}>
              <Link to="/admin/institutions-create">Crear institución</Link>
            </MenuItem>
            <MenuItem icon={<IoCreate />}>
              <Link to="/admin/institutions-personalize">
                Personalizar institución
              </Link>
            </MenuItem>
            <MenuItem icon={<IoCreate />}>
              <Link to="/admin/institutions-modules">
                Administrar modulos activos
              </Link>
            </MenuItem>
          </SubMenu>
          <SubMenu icon={<RiAdminFill />} title="Usuarios">
            <SubMenu icon={<RiAdminFill />} title="Administradores">
              <MenuItem icon={<RiAdminFill />}>
                <Link to="/admin/admins">Lista de administradores</Link>
              </MenuItem>
              <MenuItem icon={<AiOutlineUsergroupAdd />}>
                <Link to="/admin/admins-create">Crear administrador</Link>
              </MenuItem>
            </SubMenu>
            <SubMenu icon={<FaChalkboardTeacher />} title="Coordinadores">
              <MenuItem icon={<FaChalkboardTeacher />}>
                <Link to="/admin/coordinators">Lista de coordinadores</Link>
              </MenuItem>
              <MenuItem icon={<AiOutlineUsergroupAdd />}>
                <Link to="/admin/coordinators-create">Crear coordinador</Link>
              </MenuItem>
            </SubMenu>
            <SubMenu icon={<GiTeacher />} title="Docentes">
              <MenuItem icon={<GiTeacher />}>
                <Link to="/admin/teachers">Lista de docentes</Link>
              </MenuItem>
              <MenuItem icon={<AiOutlineUsergroupAdd />}>
                <Link to="/admin/teachers-create">Crear docente</Link>
              </MenuItem>
            </SubMenu>
            <SubMenu icon={<IoMdSchool />} title="Estudiantes">
              <MenuItem icon={<IoMdSchool />}>
                <Link to="/admin/students">Listar estudiantes</Link>
              </MenuItem>
              <MenuItem icon={<AiOutlineUsergroupAdd />}>
                <Link to="/admin/students-create">Crear estudiante</Link>
              </MenuItem>
              <MenuItem icon={<AiOutlineUsergroupAdd />}>
                <Link to="/admin/students-charge">Carga masiva</Link>
              </MenuItem>
            </SubMenu>
          </SubMenu>
          <SubMenu icon={<ImBooks />} title="Contenido">
            <SubMenu icon={<TbMath />} title="Series">
              <MenuItem icon={<TbMath />}>
                <Link to="/admin/series">Lista de series</Link>
              </MenuItem>
              <MenuItem icon={<MdOutlineLibraryAdd />}>
                <Link to="/admin/series-create">Crear serie</Link>
              </MenuItem>
            </SubMenu>
            <SubMenu icon={<ImBooks />} title="Libros">
              <MenuItem icon={<ImBooks />}>
                <Link to="/admin/books">Lista de libros</Link>
              </MenuItem>
              <MenuItem icon={<MdOutlineLibraryAdd />}>
                <Link to="/admin/books-create">Crear libro</Link>
              </MenuItem>
            </SubMenu>
            <SubMenu icon={<BsBook />} title="Glosario">
              <MenuItem icon={<BsBook />}>
                <Link to="/admin/glosaries">Lista de glosarios</Link>
              </MenuItem>
              <MenuItem icon={<MdOutlineLibraryAdd />}>
                <Link to="/admin/glosaries-create">Crear glosario</Link>
              </MenuItem>
            </SubMenu>
            <SubMenu icon={<BsQuestionSquareFill />} title="Banco de preguntas">
              <MenuItem icon={<BsQuestionSquareFill />}>
                <Link to="/admin/questions">Lista de preguntas</Link>
              </MenuItem>
              <MenuItem icon={<IoCreate />}>
                <Link to="/admin/questions-create">Crear pregunta</Link>
              </MenuItem>
              <MenuItem icon={<BsQuestionSquareFill />}>
                <Link to="/admin/contextquestions">Lista de contextos</Link>
              </MenuItem>
              <MenuItem icon={<IoCreate />}>
                <Link to="/admin/contextquestions-create">Crear contexto</Link>
              </MenuItem>
            </SubMenu>
            <SubMenu icon={<BiTestTube />} title="Actividades">
              <MenuItem icon={<BiTestTube />}>
                <Link to="/admin/workshops">Lista de actividades</Link>
              </MenuItem>
              <MenuItem icon={<IoCreate />}>
                <Link to="/admin/workshops-create">Crear actividad</Link>
              </MenuItem>
            </SubMenu>
            <SubMenu icon={<IoLibraryOutline />} title="Biblioteca de recursos">
              <MenuItem icon={<IoLibraryOutline />}>
                <Link to="/admin/resources">Lista de recursos</Link>
              </MenuItem>
              <MenuItem icon={<MdOutlineLibraryAdd />}>
                <Link to="/admin/resources-create">Crear recurso</Link>
              </MenuItem>
            </SubMenu>
          </SubMenu>
          <SubMenu icon={<TbMath />} title="Asignaturas">
            <MenuItem icon={<TbMath />}>
              <Link to="/admin/asignatures">Lista de asignaturas</Link>
            </MenuItem>
            <MenuItem icon={<TbMath />}>
              <Link to="/admin/asignatures-create">Crear asignatura</Link>
            </MenuItem>
          </SubMenu>
          <SubMenu icon={<AiFillPushpin />} title="Pines">
            <MenuItem icon={<AiFillPushpin />}>
              <Link to="/admin/pines">Listar pines</Link>
            </MenuItem>
            <MenuItem icon={<BiMessageSquareAdd />}>
              <Link to="/admin/pines-create">Crear pines</Link>
            </MenuItem>
          </SubMenu>
          <SubMenu icon={<ImSortNumericAsc />} title="Grados">
            <MenuItem icon={<ImSortNumericAsc />}>
              <Link to="/admin/grades">Lista de grados</Link>
            </MenuItem>
            <MenuItem icon={<BiMessageSquareAdd />}>
              <Link to="/admin/grades-create">Crear grado</Link>
            </MenuItem>
          </SubMenu>
          <SubMenu icon={<GiUpgrade />} title="Cursos">
            <MenuItem icon={<GiUpgrade size={20} />}>
              <Link to="/admin/courses">Lista de cursos</Link>
            </MenuItem>
            <MenuItem icon={<BiMessageSquareAdd size={20} />}>
              <Link to="/admin/courses-create">Crear cursos</Link>
            </MenuItem>
          </SubMenu>
          <SubMenu title="Calificaciones" icon={<FaRegListAlt />}>
            <MenuItem icon={<FaRegListAlt />}>
              <Link to="/admin/califications-activities">Actividades</Link>
            </MenuItem>
            <MenuItem icon={<FaRegListAlt />}>
              <Link to="/admin/califications-questionnaires">
                Cuestionarios
              </Link>
            </MenuItem>
          </SubMenu>
          <MenuItem icon={<FaTools />}>
            <Link to="/admin/maintenance">Mantenimiento</Link>
          </MenuItem>
        </Menu>
      </SidebarContent>
      <SidebarFooter>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            paddingTop: '20px',
            paddingBottom: '20px',
          }}
        >
          <span>v1.1.5</span>
        </div>
      </SidebarFooter>
    </ProSidebar>
  );
}
